import Search from '@mui/icons-material/Search';
import { Box, Divider, IconButton, TextField, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import _ from 'lodash';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';
import { fetchKoreSubscriptionByICCID } from '@sophocles/entities/KoreSubscription/actions';
import { addToast } from '@sophocles/features/toast';

function ActivationQueryView(props) {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [iccid, setICCID] = useState('');
  const [data, setData] = useState(null);

  const handleQuery = () => {
    setIsLoading(true);
    dispatch(fetchKoreSubscriptionByICCID(iccid))
      .then(res => {
        addToast({
          title: 'Success',
          message: 'Subscription information retrieved',
          level: 'success',
          dismissible: true,
        });
        setData(res);
      })
      .catch(err => {
        dispatch(
          addToast({
            title: 'Error',
            message: 'Error while fetching subscription',
            level: 'error',
            dismissible: true,
          }),
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleSearchKeyDown = e => {
    if (e.keyCode === 13) {
      handleQuery();
    }
  };

  return (
    <AppNav loading={isLoading} page={`admin_query-activation-status`} notFullHeight={true} {...props}>
      <Box sx={{ top: '64px', mx: 2, pb: '24px' }}>
        <TitleBar showBackButton title="Activation Status Query" />
        <Paper sx={{ mx: 1, p: 2 }}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <TextField
              fullWidth
              size="small"
              label="ICCID"
              value={iccid}
              onKeyDown={e => handleSearchKeyDown(e)}
              onChange={e => {
                setICCID(e.target.value);
              }}
            />
            <IconButton onClick={handleQuery} sx={{ ml: 1 }}>
              <Search />
            </IconButton>
          </div>
          <Divider sx={{ my: 2 }} />
          {!data ? (
            <Typography variant="caption">Enter ICCID and click search or press enter to search.</Typography>
          ) : (
            <div>
              <Typography variant="h6">IP Address</Typography>
              <Typography>{data.ip_address}</Typography>
              <Typography variant="h6">State</Typography>
              <Typography>{data.state}</Typography>
            </div>
          )}
        </Paper>
      </Box>
    </AppNav>
  );
}

export default ActivationQueryView;
